// 📧 GOOGLE DRIVE SERVICE - VERSÃO ULTRA SIMPLES
// Frontend → Backend → Email para scalone@refricril.com.br → Pronto!

export interface DriveFile {
  name: string;
  size: number;
  type: string;
  dataUrl: string;
}

export interface UploadResult {
  status: 'success' | 'error';
  message: string;
  arquivo?: string;
  destino?: string;
  timestamp?: string;
}

class GoogleDriveServiceUltraSimples {
  private backendUrl = 'http://localhost:5001';

  constructor() {
    console.log('📧 Google Drive Service - ULTRA SIMPLES');
    console.log('🎯 Frontend → Email para scalone@refricril.com.br');
    console.log('✅ Sem APIs, sem autenticação, sem complicação!');
  }

  // Verificar status do sistema
  async checkStatus(): Promise<boolean> {
    try {
      const response = await fetch(`${this.backendUrl}/api/status`);
      const data = await response.json();
      
      console.log('📊 Status:', data.status);
      console.log('📧 Email funcionando:', data.email_funcionando);
      
      return data.status === 'online';
    } catch (error) {
      console.warn('⚠️ Backend não disponível:', error);
      return false;
    }
  }

  // "Autenticação" super simples (sempre funciona!)
  async authenticate(): Promise<boolean> {
    console.log('🚀 Sistema ultra simples - sem autenticação necessária!');
    
    const status = await this.checkStatus();
    
    if (status) {
      console.log('✅ Sistema online e pronto!');
      return true;
    } else {
      console.log('⚠️ Sistema offline, mas pode tentar mesmo assim');
      return true; // Sempre permite tentar
    }
  }

  // Verificar se está "autenticado" (sempre true)
  isAuthenticated(): boolean {
    return true;
  }

  // Logout (sem efeito, apenas para compatibilidade)
  logout(): void {
    console.log('🚪 Logout (ultra simples): nada a fazer');
  }

  // Upload ultra simples
  async uploadFile(file: DriveFile, userInfo?: any): Promise<UploadResult> {
    try {
      console.log('📧 Enviando arquivo por email:', file.name);
      console.log('📍 Destino: scalone@refricril.com.br');
      
      const payload = {
        file: file,
        usuario: userInfo || {
          nome: 'Usuário Escalone',
          email: 'usuario@escalone.com',
          empresa: 'Escalone'
        }
      };
      
      const response = await fetch(`${this.backendUrl}/api/upload-arquivo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        console.log('✅ Email enviado com sucesso!');
        console.log(`📧 Arquivo "${result.arquivo}" enviado para ${result.destino}`);
        
        return {
          status: 'success',
          message: result.message,
          arquivo: result.arquivo,
          destino: result.destino,
          timestamp: result.timestamp
        };
      } else {
        throw new Error(result.message || 'Upload falhou');
      }

    } catch (error) {
      console.error('❌ Erro no upload:', error);
      
      return {
        status: 'error',
        message: error instanceof Error ? error.message : 'Erro desconhecido'
      };
    }
  }

  // Testar sistema
  async testSystem(): Promise<UploadResult> {
    try {
      console.log('🧪 Testando sistema...');
      
      const response = await fetch(`${this.backendUrl}/api/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        console.log('✅ Teste enviado!');
        console.log(`📧 Arquivo "${result.arquivo}" enviado para ${result.destino}`);
        
        return {
          status: 'success',
          message: `Teste enviado! Verifique a caixa de entrada de ${result.destino}`,
          arquivo: result.arquivo,
          destino: result.destino
        };
      } else {
        throw new Error(result.message || 'Teste falhou');
      }

    } catch (error) {
      console.error('❌ Erro no teste:', error);
      
      return {
        status: 'error',
        message: error instanceof Error ? error.message : 'Erro desconhecido'
      };
    }
  }

  // Métodos de compatibilidade (para não quebrar frontend existente)
  
  async createFolder(name: string): Promise<string> {
    console.log(`📁 Pasta "${name}": você salva onde quiser após receber email!`);
    return 'manual-save';
  }

  async getFolders(): Promise<any[]> {
    console.log('📁 Sem listagem - você organiza como quiser!');
    return [{ id: 'email', name: 'Via Email' }];
  }

  getClientId(): string {
    return 'ultra-simples-email-direto';
  }

  // Instruções para o usuário
  showInstructions(): void {
    console.log('');
    console.log('📧 SISTEMA ULTRA SIMPLES - ESCALONE');
    console.log('==================================');
    console.log('');
    console.log('🎯 COMO FUNCIONA:');
    console.log('1. 📤 Você faz upload aqui');
    console.log('2. 📧 Sistema envia email para scalone@refricril.com.br');
    console.log('3. 📥 Você recebe email com anexo');
    console.log('4. 💾 Você salva onde quiser!');
    console.log('');
    console.log('✅ VANTAGENS:');
    console.log('• Sem Google APIs');
    console.log('• Sem autenticação');
    console.log('• Sem configuração complexa');
    console.log('• Funciona sempre!');
    console.log('• Você controla onde salvar');
    console.log('');
    console.log('📧 DESTINO: scalone@refricril.com.br');
    console.log('');
  }
}

// Instância singleton
export const googleDriveService = new GoogleDriveServiceUltraSimples();

// Mostrar instruções automaticamente
googleDriveService.showInstructions();

export default googleDriveService;
